// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DateLabelController from "./date_label_controller"
application.register("date-label", DateLabelController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DropZoneController from "./drop_zone_controller"
application.register("drop-zone", DropZoneController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FacetsController from "./facets_controller"
application.register("facets", FacetsController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FireworksController from "./fireworks_controller"
application.register("fireworks", FireworksController)

import ImportProgressController from "./import_progress_controller"
application.register("import-progress", ImportProgressController)

import LiveCountController from "./live_count_controller"
application.register("live-count", LiveCountController)

import LiveRowController from "./live_row_controller"
application.register("live-row", LiveRowController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import PasskeyController from "./passkey_controller"
application.register("passkey", PasskeyController)

import PlatformController from "./platform_controller"
application.register("platform", PlatformController)

import PlatformTabsController from "./platform_tabs_controller"
application.register("platform-tabs", PlatformTabsController)

import PulseController from "./pulse_controller"
application.register("pulse", PulseController)

import PwaInstallController from "./pwa_install_controller"
application.register("pwa-install", PwaInstallController)

import QueryStartersController from "./query_starters_controller"
application.register("query-starters", QueryStartersController)

import RequireSelectionController from "./require_selection_controller"
application.register("require-selection", RequireSelectionController)

import SearchFocusController from "./search_focus_controller"
application.register("search-focus", SearchFocusController)

import TagAutocompleteController from "./tag_autocomplete_controller"
application.register("tag-autocomplete", TagAutocompleteController)

import TagFoldController from "./tag_fold_controller"
application.register("tag-fold", TagFoldController)

import TagSuggestionsController from "./tag_suggestions_controller"
application.register("tag-suggestions", TagSuggestionsController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)
